module.exports = __webpack_public_path__ + "img/ic-grid-selected.ed2be66b.svg";